<template>
  <div>
    <BigHeader  title="LISA Consortium" subtitle="" icon1="" line1="" icon2=""  line2="" icon3=""  line3=""></BigHeader>


    <v-container flex grid-list-xl  class="pb-0">

      <v-layout
        text-xs-center
        wrap
      >

        <v-flex xs12 md10 xl8 offset-md1 offset-xl2  class="mb-3">

          <v-layout
            text-xs-left
            wrap
          >

            <v-flex xs12>

              <v-layout
                text-xs-left
                wrap
              >

                <v-flex id="lisa" xs12 md8 order-xs2 order-sm2 order-md1>
                  <div class="title ml-3 mb-3">1232 Members</div>
                  <v-card style="border-radius: 3px; border: 1px solid lightgray;     " class="elevation-0">
                    <v-card-text>

                      <v-container grid-list-sm fluid>
                        <v-layout row wrap>
                          <v-flex
                            v-for="n in 9"
                            :key="n"

                            xs6
                            sm3
                            md3
                            lg2
                            d-flex
                          >
                            <v-card flat tile class="d-flex">
                              <v-img
                                :src="`https://picsum.photos/500/300?image=${n * 5 + 11}`"
                                :lazy-src="`https://picsum.photos/10/6?image=${n * 5 + 11}`"
                                aspect-ratio="1"
                                class="grey lighten-2"
                              >
                                <template v-slot:placeholder>
                                  <v-layout
                                    fill-height
                                    align-center
                                    justify-center
                                    ma-0
                                  >
                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                  </v-layout>
                                </template>
                              </v-img>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-container>

                    </v-card-text>
                  </v-card>

                </v-flex>
                <v-flex xs12 md4 order-xs1 order-sm1 order-md2>

                  <div class="title ml-3 mb-3">Filters</div>

                  <v-card style="border-radius: 3px; border: 1px solid lightgray;     height: calc(100% - 32px);" class="elevation-0">

                    <v-card-text>
                    <v-select
                      :items="['Science', 'Data Analysis', 'Outreach']"
                      box
                      label="Working group"
                    ></v-select>

                    <v-select
                      :items="['Germany', 'France', 'USA', 'China']"
                      box
                      label="Country"
                    ></v-select>

                      <v-select
                        :items="['Albert Einstein Institute', 'ESA', 'NASA', 'HUST']"
                        box
                        label="Affiliation"
                      ></v-select>
                    </v-card-text>
                  </v-card>

                </v-flex>

              </v-layout>

            </v-flex>
          </v-layout>
        </v-flex>

      </v-layout>

    </v-container>

<div style="height:600px;"></div>
  </div>
</template>

<script>

  import BigHeader from '../components/BigHeader'

  export default {
    components: {
      BigHeader
    },
    data () {
      return {


      }
    }
  }
</script>
